(function() {
    angular
        .module("app")
        .factory("globals", globals)

    globals.$inject = [
        "$rootScope"
    ]

    function globals(
        $rootScope
    ){
        "use strict"

        let _log      = console.log
        let _logWarn  = console.warn
        let _logError = console.error

        console.bypass = console.log

        console.debug = function(...args) {
            if ($rootScope.config.debugConsole) {
                _log("[DEBUG]", ...args)
            }
        }

        console.info = function(...args) {
            _log("[INFO]", ...args)
        }

        console.log = console.info

        console.warn = function(...args) {
            _logWarn("[WARN]", ...args)
        }

        console.error = function(...args) {
            _logError("[ERROR]", ...args)
        }

        const __deepValidElementTypes = ["string", "number", "boolean"]

        $rootScope.deepCopy = (from) => {

            if (Object.prototype.toString.call(from) === "[object Object]") {

                let newObject = {}

                for (const key of Object.keys(from)) {

                    let newElement = $rootScope.deepCopy(from[key])

                    if (newElement !== undefined) {

                        newObject[key] = newElement

                    }
                }

                return newObject

            }

            if (Object.prototype.toString.call(from) === "[object Array]") {

                let newArray = []

                for (const value of from) {

                    let newElement = $rootScope.deepCopy(value)

                    if (newElement !== undefined) {

                        newArray.push(newElement)

                    }

                }

                return newArray

            }

            if (__deepValidElementTypes.indexOf(typeof from) >= 0) {

                return from

            }

            return undefined

        }

        $rootScope.deepUpdate = (to, from) => {

            if (Object.prototype.toString.call(to) === "[object Object]" && Object.prototype.toString.call(from) === "[object Object]") {

                for (const key of Object.keys(to)) {

                    if (from.hasOwnProperty(key)) {

                        if (Object.prototype.toString.call(to[key]) === "[object Object]" || Object.prototype.toString.call(to[key]) === "[object Array]") {

                            $rootScope.deepUpdate(to[key], from[key])

                        } else if (__deepValidElementTypes.indexOf(typeof from[key]) >= 0) {

                            to[key] = from[key]

                        }
                    }
                }

            } else if (Object.prototype.toString.call(to) === "[object Array]" && Object.prototype.toString.call(from) === "[object Array]") {

                for (let i = 0; i < to.length; i++) {

                    if (from.length <= i) {
                        return
                    }

                    if (Object.prototype.toString.call(to[i]) === "[object Object]" || Object.prototype.toString.call(to[i]) === "[object Array]") {

                        $rootScope.deepUpdate(to[i], from[i])

                    } else if (__deepValidElementTypes.indexOf(typeof from[i]) >= 0) {

                        to[i] = from[i]

                    }
                }
            }
        }

        $rootScope.deepOverwrite = (to, from) => {

            if (Object.prototype.toString.call(to) === "[object Object]" && Object.prototype.toString.call(from) === "[object Object]") {

                for (const key of Object.keys(from)) {

                    if (to.hasOwnProperty(key)) {

                        if (Object.prototype.toString.call(from[key]) === "[object Object]" || Object.prototype.toString.call(from[key]) === "[object Array]") {

                            $rootScope.deepOverwrite(to[key], from[key])

                        } else if (__deepValidElementTypes.indexOf(typeof from[key]) >= 0) {

                            to[key] = from[key]

                        }

                    } else {

                        to[key] = from[key]

                    }
                }

                for (const key of Object.keys(to)) {

                    if (!from.hasOwnProperty(key)) {

                        delete to[key]

                    }
                }

            } else if (Object.prototype.toString.call(to) === "[object Array]" && Object.prototype.toString.call(from) === "[object Array]") {

                for (let i = 0; i < from.length; i++) {

                    if (to.length <= i) {

                        to.push(from[i])
                        continue

                    }

                    if (Object.prototype.toString.call(to[i]) === "[object Object]" || Object.prototype.toString.call(to[i]) === "[object Array]") {

                        $rootScope.deepOverwrite(to[i], from[i])

                    } else if (__deepValidElementTypes.indexOf(typeof from[i]) >= 0) {

                        to[i] = from[i]

                    }
                }

                const toExtra = to.length - from.length

                for (let i = 0; i < toExtra; i++) {

                    to.pop()

                }

            } else {

                to = from

            }


        }

        const DEBUG = false

        $rootScope.equivalent2 = (one, two) => {

            // Undefined and Null are treated as equivalent

            if (one === undefined || one === null) {

                if (two !== undefined && two !== null) { if (DEBUG) { console.log("1", one, two) }; return false }

                return true

            }

            if (two === undefined || two === null) { if (DEBUG) { console.log("2", one, two) }; return false }

            if (__deepValidElementTypes.indexOf(typeof one) >= 0) {

                if (one !== two) { if (DEBUG) { console.log("3", one, two) }; return false }

                return true

            }

            if (__deepValidElementTypes.indexOf(typeof two) >= 0) { if (DEBUG) { console.log("4", one, two) }; return false }

            if (Object.prototype.toString.call(one) === "[object Object]") {

                if (Object.prototype.toString.call(two) !== "[object Object]") { if (DEBUG) { console.log("5", one, two) }; return false }

                const oneKeys = Object.keys(one).filter((val) => { return !val.startsWith("$$") })
                const twoKeys = Object.keys(two).filter((val) => { return !val.startsWith("$$") })

                if (oneKeys.length !== twoKeys.length) { if (DEBUG) { console.log("6", oneKeys, twoKeys) }; return false }

                for (const key of oneKeys) {

                    if (!twoKeys.contains(key)) { if (DEBUG) { console.log("7", key) }; return false }

                    if (!$rootScope.equivalent2(one[key], two[key])) { if (DEBUG) { console.log("8", one, two) }; return false }

                }

                return true

            }

            if (Object.prototype.toString.call(two) === "[object Object]") { if (DEBUG) { console.log("9", one, two) }; return false }

            if (Object.prototype.toString.call(one) === "[object Array]") {

                if (Object.prototype.toString.call(two) !== "[object Array]") { if (DEBUG) { console.log("10", one, two) }; return false }

                if (one.length !== two.length) { if (DEBUG) { console.log("11", one, two) }; return false }

                for (let i = 0; i < one.length; i += 1) {

                    if (!$rootScope.equivalent2(one[i], two[i])) { if (DEBUG) { console.log("12", one, two) }; return false }

                }

                return true

            }

            if (Object.prototype.toString.call(two) === "[object Array]") { if (DEBUG) { console.log("13", one, two) }; return false }

            // Not a string, number, boolean, object, array, undefined, or null
            if (DEBUG) { console.log("14", one, two) }; return false

        }

        $rootScope.equivalent = (one, two) => {

            if (Object.prototype.toString.call(one) === "[object Object]") {

                if (Object.prototype.toString.call(two) === "[object Object]") {

                    for (const key of Object.keys(one)) {

                        if (!two.hasOwnProperty(key)) {
                            return false
                        }

                        if (!$rootScope.equivalent(one[key], two[key])) {
                            return false
                        }
                    }

                } else {

                    return false

                }

            } else if (Object.prototype.toString.call(two) === "[object Object]") {

                return false

            } else if (Object.prototype.toString.call(one) === "[object Array]") {

                if (Object.prototype.toString.call(two) === "[object Array]") {

                    if (one.length !== two.length) {
                        return false
                    }

                    for (let i = 0; i < one.length; i++) {

                        if (!$rootScope.equivalent(one[i], two[i])) {
                            return false
                        }
                    }

                } else {

                    return false

                }

            } else if (Object.prototype.toString.call(two) === "[object Array]") {

                return false

            } else if (__deepValidElementTypes.indexOf(typeof one) >= 0) {

                if (one !== two) {

                    return false

                }
            }

            return true

        }

        return 1

    }
})()
